import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { serviceInstance } from "utils/axiosInstances";
import { getResourcesBucket } from "config";
import { fileDisplayValue } from "./types";

const getDisplayUrlByKey = createAsyncThunk<fileDisplayValue, string, {}>(
  "fileDisplay/getByKey",
  async (key: string) => {
    const response = await serviceInstance.post("/presignedGET", {
      bucket: getResourcesBucket(),
      key,
      timeout: 300,
    });
    return response.data.url as fileDisplayValue;
  }
);

const initialState: fileDisplayValue = {
  url: "",
};

const fileDisplaySlice = createSlice({
  name: "fileDisplay",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDisplayUrlByKey.fulfilled, (state, action) => {
      return action.payload;
    });
    builder.addCase(getDisplayUrlByKey.rejected, (state, action) => {
      return { error: action.error };
    });
  },
});

export { getDisplayUrlByKey };
export default fileDisplaySlice.reducer;
